// Validate a CURP: 18 chars, positions 5-10 must be digits, rest letters/digits.
// Regex simplificado siguiendo el formato XXXX######XXXXXXXX.
export function isValidCURP(curpRaw) {
  const curp = (curpRaw || "").toUpperCase().trim();
  return /^[A-Z0-9]{4}[0-9]{6}[A-Z0-9]{8}$/.test(curp);
}

// CURP parser: extracts DOB and gender from an 18-char CURP.
// Positions 5-10: YYMMDD | Position 11: H (male) / M (female)

const ENTIDADES = {
  AS: "Aguascalientes", BC: "Baja California", BS: "Baja California Sur",
  CC: "Campeche", CL: "Coahuila", CM: "Colima", CS: "Chiapas", CH: "Chihuahua",
  DF: "Ciudad de México", DG: "Durango", GT: "Guanajuato", GR: "Guerrero",
  HG: "Hidalgo", JC: "Jalisco", MC: "México", MN: "Michoacán", MS: "Morelos",
  NT: "Nayarit", NL: "Nuevo León", OC: "Oaxaca", PL: "Puebla", QT: "Querétaro",
  QO: "Querétaro",
  QR: "Quintana Roo", SP: "San Luis Potosí", SL: "Sinaloa", SR: "Sonora",
  TC: "Tabasco", TS: "Tamaulipas", TL: "Tlaxcala", VZ: "Veracruz", YN: "Yucatán",
  ZS: "Zacatecas", NE: "Nacido en el Extranjero",
};

export function parseCURP(curpRaw) {
  const curp = (curpRaw || "").toUpperCase().trim();
  if (curp.length < 11) return null;
  const yy = curp.substring(4, 6);
  const mm = curp.substring(6, 8);
  const dd = curp.substring(8, 10);
  const gender = curp[10];
  if (!/^\d{6}$/.test(yy + mm + dd)) return null;
  if (gender !== "H" && gender !== "M") return null;

  const nowYY = new Date().getFullYear() % 100;
  const yyNum = parseInt(yy, 10);
  const century = yyNum <= nowYY ? 2000 : 1900;
  const year = century + yyNum;
  const fecha = `${year}-${mm}-${dd}`;

  const entidadCode = curp.substring(11, 13);
  const entidad = ENTIDADES[entidadCode] || "";

  return { fecha_nacimiento: fecha, genero: gender, entidad_nacimiento: entidad };
}

// Años cumplidos a una fecha de corte específica (YYYY-MM-DD).
export function edadEnFecha(fechaISO, cutoffISO) {
  if (!fechaISO || !cutoffISO) return "";
  const [fy, fm, fd] = fechaISO.split("-").map(Number);
  const [cy, cm, cd] = cutoffISO.split("-").map(Number);
  if (!fy || !fm || !fd || !cy || !cm || !cd) return "";
  const dob = new Date(fy, fm - 1, fd);
  const cutoff = new Date(cy, cm - 1, cd);
  let age = cutoff.getFullYear() - dob.getFullYear();
  const beforeBirthday =
    cutoff.getMonth() < dob.getMonth() ||
    (cutoff.getMonth() === dob.getMonth() && cutoff.getDate() < dob.getDate());
  if (beforeBirthday) age -= 1;
  return Math.max(age, 0);
}

// Legacy — años cumplidos al 1 de septiembre del año de inicio del ciclo.
export function edadAlPrimeroSep(fechaISO, ciclo = "2026-2027") {
  const startYear = parseInt((ciclo || "").split("-")[0], 10) || new Date().getFullYear();
  return edadEnFecha(fechaISO, `${startYear}-09-01`);
}

// Retorna "Profr." (masculino) o "Profra." (femenino) según la posición 11 de la CURP.
// En mayúsculas/minúsculas — al usarse en contenedores con `uppercase` (firmas)
// se convertirá automáticamente a mayúsculas, y en cursivas (nombre) mantiene el mixto elegante.
export function prefijoDocenteFromCurp(curp, fallback = "Profr(a).") {
  const g = parseCURP(curp)?.genero;
  if (g === "H") return "Profr.";
  if (g === "M") return "Profra.";
  return fallback;
}

// Retorna una versión con género del cargo (ej. "Director"/"Directora") según CURP.
export function cargoConGeneroFromCurp(curp, masculino, femenino, fallback) {
  const g = parseCURP(curp)?.genero;
  if (g === "H") return masculino;
  if (g === "M") return femenino;
  return fallback ?? `${masculino}(a)`;
}
